<section class="contact-top">
    
    <div class="inner_sec">

       <div class="container">     
         <h2>Moulding Tools Manufacturing.</h2>
       </div> 
             
        <div class="tabbing_sec">

        <div class="product_list">

            <div class="product_box moulding_sec">
              
              <div class="container">
                <!-- <h3>Conveyor Systems</h3> -->
                   <div class="row">
                    
                    <div class="col-sm-6">
                        <p class="tittle">Leading tooling manufacturers with experience of 10000+ moulds</p>
                        <div class="productItem" *ngFor="let data of mouldingtoolone">
                         <div class="row">
                            <figure class="col-sm-4"> <img class="about-img" [src]="data.img" alt=""> </figure>
                            <h4 class="col-sm-6"> <lucide-icon name="ArrowRight" class="icon" [size]="18"></lucide-icon> {{data.description}}</h4>
                          </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                      <p class="tittle">Capacity of 1100+ moulds per year. (IMMC Capacities from 15 tonnes to 3200 tonnes)</p>
                      <div class="productItem" *ngFor="let data of mouldingtooltwo">
                       <div class="row">
                          <figure class="col-sm-4"> <img class="about-img" [src]="data.img" alt=""> </figure>
                          <h4 class="col-sm-6"> <span class="title"> {{data.heading}} </span>  <lucide-icon name="ArrowRight" class="icon" [size]="18"></lucide-icon>  {{data.description}}</h4>
                        </div>
                      </div>
                  </div>

                    <!-- <div class="col-sm-6">
                      <p class="tittle">Capacity of 1100+ moulds per year (IMMC Capacities from 15 tonnes to 3200 tonnes).</p>
                      <div class="productItem" *ngFor="let data of mouldingtoolone">
                       <div class="row">
                          <figure class="col-sm-6"> <img class="about-img" [src]="data.img" alt=""> </figure>
                          <h4 class="col-sm-6"> <lucide-icon name="ArrowRight" class="icon" [size]="18"></lucide-icon> {{data.description}}</h4>
                        </div>
                      </div>
                    </div> -->

                  </div>
               
              </div>

            </div>

        </div>
              
        </div>
    </div>

</section>

